import 'jquery.mmenu/dist/jquery.mmenu.all';

export default $(()=>{
    /** Mobile Navigation **/

    let $mobile = $('#mobile');
    let $mobileToggle = $('.menu-toggle');
    let isUser = $('[data-app="app"]').data('user');

    let footerContent = [
        "<a href='" + window.AppConfig.loginPath + "'> Hello! Please Login</a>"
    ];

    if(isUser == true) {
        let username = $('.account-info__name').text();

        footerContent = [
            `<a href='/account'> Hello, <strong>${username}</strong></a>`,
            "<a href='/submittal-manager'> Your Submittal Manager</a>",
        ]
    }

    $mobile.mmenu({
        "navbars": [
            {
                "position": "bottom",
                "content": footerContent
            }
        ]
    });

    // Add close button to menus
    $('.mm-panel > .mm-navbar').append('<button aria-label="menu-toggle-close" class="mmenu-close"></button>');
    let $mmenuClose = $('.mmenu-close');

    let mobileApi = $mobile.data("mmenu");

    $mobileToggle.on('click', (el) => {
        let $self = $(el);

        if ($self.hasClass('active')) {
            mobileApi.close();
            return;
        }
        mobileApi.open();
    });

    $mmenuClose.on('click', () => {
        mobileApi.close();
    });

    mobileApi.bind('close:finish', () => {
        mobileApi.closeAllPanels();
    });
});